import { type Ref, useEffect, useRef } from 'react';
import { useNavigate } from '@tanstack/react-router';

export function useRipple() {
  const ref = useRef<HTMLElement | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (ref.current) {
      const elems = ref.current.querySelectorAll<HTMLElement>('.ripple');
      elems.forEach((el) => {
        if (!el.dataset.ripple) {
          el.dataset.ripple = 'true';
          el.addEventListener('click', (e) => {
            let btn = e.target as HTMLElement;
            const link = btn.closest('a');
            if (link && link.href) {
              e.preventDefault();
              if (!link.classList.contains('ripple-no-navigate')) {
                setTimeout(() => {
                  // noinspection JSIgnoredPromiseFromCall
                  navigate({ to: link.getAttribute('href') as any, viewTransition: true });
                }, 100);
              }
            }
            if (!btn.classList.contains('ripple')) {
              btn = btn.closest('.ripple') as HTMLElement;
            }

            const rippleEffect = document.createElement('span');
            const diameter = Math.max(btn.clientWidth, btn.clientHeight);
            const radius = diameter / 2;

            rippleEffect.style.width = rippleEffect.style.height = `${diameter}px`;
            const rect = btn.getBoundingClientRect();
            rippleEffect.style.left = `${e.clientX - (rect.x + radius)}px`;
            rippleEffect.style.top = `${e.clientY - (rect.y + radius)}px`;
            rippleEffect.classList.add('ripple-effect');
            btn.querySelectorAll('.ripple-effect').forEach((el) => {
              el.remove();
            });
            btn.appendChild(rippleEffect);
            rippleEffect.addEventListener('animationend', () => {
              // rippleEffect.remove();
            });
          });
        }
      });
    }
  });
  return { ref: ref as Ref<HTMLDivElement> | undefined };
}
